<template>
  <v-dialog v-model="$parent.popup.isVisible" persistent width="400">
    <v-card>
      <v-toolbar class="trHeader" style="height: 40px;">
        <v-toolbar-title class="white--text" style="text-align:center;">{{$parent.popup.title}}</v-toolbar-title>
      </v-toolbar>
      <v-layout row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex xs3 right>
          שם חבילה
        </v-flex>
        <v-flex xs9>
          <input type="text" v-model="$parent.popup.data.Name" />
        </v-flex>
      </v-layout>
      <v-layout row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex xs3 right>
          מספר יומנים
        </v-flex>
        <v-flex xs9>
          <input type="number" v-model="$parent.popup.data.Diaries" />
        </v-flex>
      </v-layout>
      <v-layout row wrap style="padding: 20px 10px 10px 10px;">
        <v-flex xs3 right>
          מחיר ₪
        </v-flex>
        <v-flex xs9>
          <input type="number" v-model="$parent.popup.data.Price" />
        </v-flex>
      </v-layout>
      <v-flex row wrap style="padding: 10px 10px 10px 10px;">
        <span class="error" v-show="error">* {{error}}</span>
      </v-flex>
      <v-flex actions style="padding: 20px 10px 10px 10px;">
        <v-btn outline small class="green green--text ml-3" @click.native="save">
          שמירה
          <v-icon left>check</v-icon>
        </v-btn>
        <v-btn outline small class="red red--text ml-2" @click.native="cancel">
          ביטול
          <v-icon left>block</v-icon>
        </v-btn>
      </v-flex>
    </v-card>
  </v-dialog>
</template>

<script>

  export default {
    name: 'PopupPackage',
    data() {
      return {
        error: ''
      }
    },
    created() {
      this.$Log("Vue [PopupPackage] is created ...");
    },
    ready() {
      this.$Log("Vue [PopupPackage] is ready ...");
    },
    mounted() {
      this.$Log("Vue [PopupPackage] is mounted ...");
    },
    updated() {
      this.$Log("Vue [PopupPackage] is updated ...");
    },
    methods: {
      isValid() {
        if (this.$parent.popup.data.Name.trim().length <= 0) return false;
        if (this.$parent.popup.data.Diaries <= 0) return false;
        if (this.$parent.popup.data.Price <= 0) return false;
        return true;
      },
      save() {
        this.error = "";
        if (this.isValid()) {
          if (this.$parent.popup.isEdit) {
            this.$parent.update();
          }
          else {
            this.$parent.insert();
          }
          this.reset();
        }
        else {
          this.error = "נא למלא את כל השדות!"
        }
      },
      cancel() {
        this.reset();
      },
      reset() {
        this.error = "";
        this.$parent.popup = {
          isVisible: false,
          isEdit: false,
          title: '',
          data: { '.key': '', Name: '', Diaries: 0, Price: 0 }
        };
      }
    }
  }

</script>
<style>
  .error{
    color: red;
    background-color: #fff!important;
  }
</style>



// WEBPACK FOOTER //
// PopupPackage.vue?afe242a8